import axiosInstance from './apiConfig';

// Login API call
export const login = async (
  username: string,
  password: string,
): Promise<any> => {
  try {
    const response = await axiosInstance.post('/auth/login', {
      username,
      password,
    });
    return response.data;
  } catch (error) {
    throw new Error(`Login failed: ${error}`);
  }
};

// Logout (optional, if your API supports it)
export const logoutUser = async (): Promise<void> => {
  await localStorage.removeItem('mrmtoken');
};

// Update user profile API call
export const updateUserProfile = async (
  userId: number,
  payload,
): Promise<any> => {
  try {
    const response = await axiosInstance.put(
      `/auth/updateUser?userId=${userId}`,
      payload,
    );

    const userData = {
      ...response.data.data,
      accessLevels: JSON.parse(response.data.data.accessLevels),
    };
    return userData;
  } catch (error) {
    const message =
      error.response?.data?.message || 'Failed to update user profile';
    throw new Error(message);
  }
};
